'use strict';

var helper = require('../helper');

module.exports = {

    pushAddToWishlistInteraction (data) {
        var {sku, form, availability, GTMParentItemId, GTMParentItemCategory4} = data;
        sku = helper.getFormatSku(sku);
        let pushObject = null;
        if (GTMParentItemId && GTMParentItemCategory4) {
            pushObject = {
                'event': 'GAevent',
                'eventID': '20',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'eventname': 'add_to_wishlist',
                'product_id': sku,
                'position': form,
                'availability': availability,
                'parent_item_id': GTMParentItemId,
                'parent_item_category4': GTMParentItemCategory4
            };
        } else {
            pushObject = {
                'event': 'GAevent',
                'eventID': '20',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'eventname': 'add_to_wishlist',
                'product_id': sku,
                'position': form,
                'availability': availability
            };
        };

        helper.log('Pushing add to wishlist impression from ' + form + ' for sku \'' + sku + '\'!', true);
        helper.push(pushObject);
    },

    pushRemoveFromWishlistInteraction (sku, location) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '21',
            'eventname': 'remove_from_wishlist',
            'product_id': sku,
            'position': location || ''
        };

        helper.log('Pushing remove from wishlist impression for \'' + sku + '\'!', true);
        helper.push(pushObject);
    }

};
